import { RobotOutlined } from "@/icons"
import { IconTextCell } from "@/molecules/IconTextCell"

import styles from "./AgentCell.module.scss"

export const AgentCell = (name: string) => (
  <div className={styles.container}>
    <IconTextCell text={name} icon={<RobotOutlined />} />
  </div>
)
